module.exports =
  '_CONTACT':
    'TITLE': 'お問合わせ'
    'SUBJECT': "お問合せ種別"
    'YOUR_NAME': 'お名前'
    'EMAIL_ADDRESS': '返信先メールアドレス'
    'BODY': 'お問合せ内容'
    'SUBJECT_DEFAULT_TEXT': "-- こちらからお選びください --"
    'INQUIRY_SUCCESS': 'お問い合わせメールの送信が完了しました。ユーザーサポートよりメールで返信させていただきます。'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/contact/i18n/ja.coffee